/**
 * 将时间戳格式化
 * @param {*} time 时间戳 1510908337
 * @param {*} cFormat 格式 {y}-{m}-{d} {h}:{i}:{s}
 */
export function parseTimestamp(time, cFormat) {
	if(arguments.length === 0) {
		return null;
	}

	if((time + '').length === 10) {
		time = +time * 1000
	}

	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
	let date;
	if(typeof time == 'undefined' || isEmpty(time)) {
		return null;
	} else if(typeof time == 'object') {
		date = time;
	} else {
		date = new Date(parseInt(time));
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	};
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key];
		if(key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
		if(result.length > 0 && value < 10) {
			value = '0' + value;
		}
		return value || 0;
	});
	return time_str;
}

/**
 * 将默认Date格式化
 * @param {*} time Thu Nov 16 15:16:50 CST 2017
 * @param {*} cFormat yyyy-MM-dd hh:mm
 */
export function parseDateFilter(time, cFormat) {
	if(arguments.length === 0 || time === '') {
		return null;
	}
	if(typeof(arguments[0]) == 'undefined'){
		return '';
	}
	var fmt = cFormat || 'yyyy-MM-dd hh:mm:ss';
	var date = new Date(time);
	if(/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	};
	for(let k in o) {
		if(new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + '';
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
		}
	}
	return fmt;
}

/**
 * 空数据时显示的文本内容
 */
export function defaultValFilter(val) {
	return typeof val == 'undefined' || val === '' || val === null ? '--' : val;
}
/**
 * 空数据时显示0
 */
export function defaultValFilterNum(val) {
	return typeof val == 'undefined' || val === '' || val === null ? '0' : val;
}

/**
 * 保留两位小数
 */
export function twoDecimalStr(val) {
	return val = val.substring(0,val.indexOf(".") + 3);
}
export function twoDecimal(val) {
	return val = parseInt(val);
}
/**
 * 转换为数字类型
 */
export function toNumber(val) {
	return +val;
}


/**
 * @秒数转换为时分秒
 */
export function transformStringTime(s) {
	var t = "";

	function placeholder_zero(val) {
		return val.toString().length == 2 ? val : '0' + val;
	}
	if(s > -1) {
		var hour = Math.floor(s / 3600);
		var min = Math.floor(s / 60) % 60;
		var sec = s % 60;
		if(hour >= 0) {
			t += placeholder_zero(hour) + ":";
		}
		if(min >= 0) {
			t += placeholder_zero(min) + ":";
		}
		t += placeholder_zero(sec);
	}
	return t;
}
/**
 * @匹配手机号首尾，以类似“123****8901”的形式输出
 */
export function secretMobileNumber(mu) {
	var val = mu.toString();
	if(val.length != 11) {
		return val;
	} else {
		return val.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
	}
}